import React from 'react';
import { Select } from 'antd';
import { serverUrl } from '../AppConfig';

const { Option } = Select;

export function composeSelectOptions(valueList, opts, defaultOpt) {
    // console.warn('array passato: ', valueList);
    // console.warn('chiave passata: ', key);
    const arrayOptions = [];
    if (!valueList) {
        return null
    }
    
    if (defaultOpt) {
        arrayOptions.push(<Option key="default" value={defaultOpt.value}>{defaultOpt.desc}</Option>)
    } else {
        arrayOptions.push(<Option key="default" value={undefined}>-Qualsiasi-</Option>);
    }
    if (opts) {
        valueList.forEach(element => {
            let desc;
            if (opts.desc === 'name,surname') {
                desc = `${element['name']} ${element['surname']}`;
            } else {
                desc = element[opts.desc];
            }
            let opt = <Option key={element[opts.key]} value={element[opts.value]}>{desc}</Option>;
            arrayOptions.push(opt);
        });
    }
    if (valueList && !opts) {
        valueList.forEach(element => {
            let opt = <Option key={element} value={element}>{element}</Option>;
            arrayOptions.push(opt);
        });
    }
    // TODO: implementare generazione array di Select.Option con chiave stabilita da utente
    // console.warn(arrayOptions);
    return arrayOptions;
}

export const DescriptionItem = ({ title, content }) => (
    <div className="site-description-item-profile-wrapper">
      <p className="site-description-item-profile-p-label">{title}:</p>
      {content}
    </div>
  );

export function getPhoto(imageurl) {
    //console.warn('devo recuperare la foto: ', persona);
    if (imageurl === '' || !imageurl) {
        return `${serverUrl}/media/image/default_photo`;
    }
    return `${serverUrl}/images/${imageurl}`
}